import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import {
  Container,
  ContainerContent,
  ContainerHeader,
  ModelingPageContent,
  ModelingPageHeader,
} from '@/component';
import { useUnleash } from '@/package';
import { useMainLayout } from '@/provider';
import { ModelingListContextProvider } from '@/provider/modelingList';

const ModelingPage = () => {
  const { setTitle } = useMainLayout();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isEnabled } = useUnleash();
  const isModelingEnabled = isEnabled('vuex.sapporo.enabledModeling');

  useEffect(() => {
    if (isModelingEnabled) return;

    navigate('/', { replace: true });
  }, [isModelingEnabled]);

  useEffect(() => {
    setTitle(t('development.developmentButtonText.shilluh'));
  }, []);

  return (
    <ModelingListContextProvider>
      <Container>
        <ContainerHeader>
          <ModelingPageHeader />
        </ContainerHeader>

        <ContainerContent>
          <ModelingPageContent />
        </ContainerContent>
      </Container>
    </ModelingListContextProvider>
  );
};

export default ModelingPage;
